import React from 'react'
import PropTypes from 'prop-types'
import {
  MobileSortByView,
  MobilePriceView,
  MobileStoresView,
  MobileDepartmentsView,
  MobileRefineView,
  MobileColorsView
} from '../views'

const MobileViews = props => {
  const { queryString, view, data } = props
  switch (view) {
    case 'Colours': {
      return <MobileColorsView queryString={queryString} data={data} />
    }
    case 'Department': {
      return <MobileDepartmentsView queryString={queryString} data={data} />
    }
    case 'SortBy': {
      return <MobileSortByView queryString={queryString} data={data} />
    }
    case 'Price': {
      return <MobilePriceView queryString={queryString} data={data} />
    }
    case 'Stores': {
      return <MobileStoresView queryString={props.queryString} data={data} />
    }
    default: {
      return <MobileRefineView data={data} queryString={queryString} />
    }
  }
}

MobileViews.propTypes = {
  data: PropTypes.any,
  queryString: PropTypes.string,
  view: PropTypes.any
}

export default MobileViews
